import React, { useEffect, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import LButton from "components/LButton";
import { useLandingPageContext } from "pages/Context/LandinPageContext";

interface IPixPayment {
  pix: string;
}

export default function PixPayment({ pix }: IPixPayment) {
  const { timeLeftContext } = useLandingPageContext();

  const [remainingTime, setRemainingTime] = useState(timeLeftContext);
  const [expired, setExpired] = useState(false);

  useEffect(() => {
    setRemainingTime(timeLeftContext); // Atualiza o estado inicial com o valor correto

    if (timeLeftContext <= 0) {
      setExpired(true);
      return;
    }

    const timer = setInterval(() => {
      setRemainingTime((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timer);
          setExpired(true);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeftContext]);

  // Função para copiar o código Pix para a área de transferência
  const copyToClipboard = () => {
    if (!expired) {
      navigator.clipboard.writeText(pix);
    }
  };

  // Formatar tempo para minutos e segundos
  const formatTime = (time: number) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  return (
    <div className="pix-payment p-4 flex-grow-1">
      <div className="d-flex gap-4 flex-column align-items-center justify-content-around">
        <div className="w-100 d-flex flex-column justify-content-center align-items-center gap-2">
          <div className="pix-qr-code mb-3 mb-md-0">
            <QRCodeCanvas value={pix} size={150} />
          </div>

          <div className="pix-copy-code">
            <LButton
              onClick={copyToClipboard}
              className="btn btn-primary mb-2"
              disabled={expired}
            >
              Copiar código Pix
            </LButton>
          </div>
        </div>
        <div className="d-flex flex-column">
          <p className="text-muted m-0" style={{ fontSize: "1rem" }}>
            Tempo restante: <strong>{formatTime(remainingTime)}</strong>
          </p>
          <p className="text-muted" style={{ fontSize: "0.875rem" }}>
            Você pode escanear o QR Code ou copiar o código acima e colar em seu aplicativo de pagamento.
          </p>
        </div>
      </div>
    </div>
  );
}
